export const GET_ALL_CONNECTIONS = 'getAllConnections';
export const CREATE_CONNECTION = 'createConnection';
export const EDIT_CONNECTION = 'editConnection';
export const REMOVE_CONNECTION = 'removeCOnnection';
export const CURRENT_API_STATUS = 'currentApiStatus';

export const SET_ALL_CONNECTIONS = 'setAllConnection';
export const ADD_NEW_CONNECTION = 'addNewConnection';
export const UPDATE_EDITED_CONNECTION = 'updateEditedConnection';
export const UPDATE_API_CALL_STATUS = 'updateApiCallStatus';
export const REMOVE_CONNECTION_MUTATION = 'removeConnectionMutation';
export const SET_ERROR_MESSAGE = 'setErrorMessage';
export const UPDATE_SEARCH_SERVICE = 'updateSearchService';
